import Modal from '@patientpattern/coat/ui/Modal';
import useTimeout from '@patientpattern/utils/hooks/useTimeout';

import {logout} from './api';

type SessionExpirationModalProps = {
    isOpen: boolean;
    expireAfter?: number;
    onClose: () => void;
};

const SessionExpirationModal = ({
    isOpen,
    expireAfter = 60000,
    onClose,
}: SessionExpirationModalProps) => {
    useTimeout(logout, isOpen ? expireAfter : null);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            title="Your session is about to expire"
            primaryAction={{
                children: 'Stay Signed In',
                onClick: onClose,
                testAttr: 'stay',
            }}
        >
            Click the button below to stay signed in.
        </Modal>
    );
};

export default SessionExpirationModal;
